































































import { Market } from '@/store/modules/market'
import { Vue, Component, Watch } from 'vue-property-decorator'
import OverviewUsers from './OverviewUsers.vue'
import OverviewChart from './OverviewChart.vue'
import OverviewResources from './OverviewResources.vue'
import OverviewSlides from './OverviewSlides.vue'
import { hasPermissions } from '@/utils/auth'
import { EventBus } from '@/utils/event-bus'

@Component({
  components: {
    OverviewUsers,
    OverviewChart,
    OverviewResources,
    OverviewSlides
  }
}
)
export default class Stats extends Vue {
  hasPermissions = hasPermissions
  pageTitle: string = 'Stats';
  dateFrom: Date = new Date(new Date().getFullYear(),
    new Date().getMonth() - 1,
    new Date().getDate());

  dateTo: Date = new Date();

  dateToMax: Date = new Date();
  checked: boolean = false;
  selectedMarket: string = this.$store.getters.getSelectedMarket
  componentReadyCount: number = 0

  // watch for filter changes
  @Watch('markets')
  @Watch('dateTo')
  @Watch('dateFrom')
  @Watch('marketKey')
  onFilterChange () {
    EventBus.$emit('show-loader')
    this.componentReadyCount = 0
  }

  mounted () {
    this.$store.dispatch('loadMarkets')
    EventBus.$emit('show-loader')
  }

  @Watch('componentReadyCount')
  onComponentReadyCountChange () {
    if (this.componentReadyCount === 4) {
      document.body.scrollTop = document.documentElement.scrollTop = 0
      EventBus.$emit('hide-loader')
    }
  }

  incrementCount () {
    this.componentReadyCount++
  }

  // getters
  get markets () {
    const markets = this.$store.getters.getMarkets
    return markets.map((market: Market) => {
      return {
        value: market.key,
        text: market.name
      }
    })
  }

  toggleCheckbox () {
    this.checked = !this.checked
  }

  get dateFormatOptions () {
    return { year: 'numeric', month: 'short', day: 'numeric' }
  }
}
